
<div fxLayout.xs="column" fxLayout="row"  >

    <div fxLayout="column" fxFlex style="padding: 35px;">
        <h2> <calsoft-editor-text [data]="data"
            style="font-family: var(--website-font-family);" 
            [text]="item?.title" 
            [fontSize]="item.customField11"
            [MobfontSize]="item.customField12">
        </calsoft-editor-text> </h2>
        <p> <calsoft-editor-text [data]="data" 
            style="font-family: var(--website-font-family);" 
            [text]="item?.customField24" 
            [fontSize]="item.customField11"
            [MobfontSize]="item.customField12">
        </calsoft-editor-text> </p>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" style="margin-top: 50px; margin-bottom: 15px;">
            <button
              mat-raised-button
              [class.active]="!isChecked"
              [style.border-color]="isChecked ? 'transparent' : 'black'"
              (click)="setToggle(false)">
              {{item.customField20}}
            </button>
            <button
              mat-stroked-button
              [class.active]="isChecked"
              [style.border-color]="isChecked ? 'transparent' : 'black'"
              (click)="setToggle(true)">
              {{item.customField21}}
            </button>
          </div>
          
          
    </div>
    <div fxFlex="5"></div>
    <div fxFlex="30" fxFlex.xs="100">
        <div fxLayout="column" fxLayout.gt-sm="row" style="text-align: center;" fxLayoutGap="15px"
            *ngFor="let data of pricedetail">
            <div contentAnim [aniName]="item.customField36" fxFlex="100" 
                style="border-radius: 20px ;box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.15);padding: 20px ">
                <h3 style="font-size: 30px;font-weight: bold;"><b>{{data.title1}}</b></h3>
                <h5 style="font-size: 16px;">{{data.s_subtitle}}</h5>
               

                <div  *ngIf="!isChecked">
                    <h4 style="font-size: 40px;font-weight: bold;"><b>₹ {{data.s_price_annualy}}</b></h4>
                    <h6 style="font-size: 20px;font-weight: bold;">{{data.s_charge_year}}</h6>
                </div>
                <div  *ngIf="isChecked">
                    <h4 style="font-size: 40px;font-weight: bold;"><b>₹ {{data.s_price_life}}</b></h4>
                    <h6 style="font-size: 20px;font-weight: bold;">{{data.s_charge_life}}</h6>
                </div>

                
              

                <div fxLayout="row" fxLayoutAlign="center center" *ngFor="let subdata of data.list_detail" style="margin-bottom: 10px;">
                    <div fxFlex="10"></div>
                    <div fxFlex fxLayoutAlign="start center"  class="pricelist" *ngIf="subdata.starters">
                        <mat-icon class="maticon3">check_circle</mat-icon>
                        <h6 style="margin-bottom: 0px;">&#160;&#160;{{subdata.starters}}</h6>
                    </div>
                    <div fxFlex="10"></div>
                </div>
                <!-- <div>
                <div class="pricelist" >
                    <mat-icon class="maticon3">check_circle</mat-icon>
                    <h6 style="margin-bottom: 0px;">&#160;Partial Payment</h6>                
                </div>
            </div> -->

            <button (click)="openInNewWindow(data.p_button)" mat-raised-button 
                   style="background-color:var(--primary-color); color: white;margin-top: 30px;" >{{data.s_button}}</button>

            </div>

        </div>
    </div>
    



</div>
